<div class="custom-select" [class.disabled]="disabled">
  <div #selectTrigger class="select-trigger" (click)="toggleDropdown()">
    {{ selectedOption || placeholder }}
    <i class="fa-regular fa-chevron-down"></i>
  </div>
  @if (dropdownOpen) {
    <div #selectItems class="select-items" [ngClass]="positionClass">
      @for (option of options; track $index) {
        <div (click)="selectOption(option)">
          {{ option.label }}
        </div>
      }
    </div>
  }
</div>
